import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RecaptchaViewModel, SelfUserUpdateREQ, UnregisteredUserViewModel, UserViewModel } from '@program-suite/data-common';
import { firstValueFrom } from 'rxjs';
import { SnackbarComponent, ToastType } from '@program-suite/ui';
import { MatSnackBar } from '@angular/material/snack-bar';
import { propagateError } from '@program-suite/util-helpers';

@Injectable({ providedIn: 'root' })
export class UserService {
  http = inject(HttpClient);
  snackbar = inject(MatSnackBar);

  async getUser(): Promise<UserViewModel> {
    try {
      return await firstValueFrom(this.http.get<UserViewModel>('User'));
    } catch (error) {
      throw new Error('Failed to get user');
    }
  }

  async getUnregisteredUser(inviteGuid: string): Promise<UnregisteredUserViewModel> {
    try {
      return await firstValueFrom(this.http.get<UnregisteredUserViewModel>(`user/unregistered/${inviteGuid}`));
    } catch (error) {
      propagateError(error);
      throw new Error('Failed to get unregistered user');
    }
  }

  async updateUserProfile(user: SelfUserUpdateREQ): Promise<boolean> {
    try {
      const response =  await firstValueFrom(this.http.post<number>('user', user, { observe: 'response' }));
      this.snackbar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        data: { toastType: ToastType.Success, message: "Profile Updated" },
      });
      return response.status === 200;
    } catch (error) {
      throw new Error('Failed to update user profile');
    }
  }

  async resendExpiredInvite(model: RecaptchaViewModel): Promise<HttpResponse<void>> {
    try {
      const response = await firstValueFrom(
        this.http.post<void>('user/resend-expired-invite', model, { observe: 'response' })
      );
      this.snackbar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        data: { toastType: ToastType.Success, message: "Invitation resent successfully. Use the new invitation link to register." }
      });
      return response;
    } catch (error) {
      throw new Error('Failed to resend expired invite');
    }
  }
}
